import { render, staticRenderFns } from "./FormGoh.vue?vue&type=template&id=0f54e432&scoped=true"
import script from "./FormGoh.vue?vue&type=script&lang=js"
export * from "./FormGoh.vue?vue&type=script&lang=js"
import style0 from "./FormGoh.vue?vue&type=style&index=0&id=0f54e432&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f54e432",
  null
  
)

export default component.exports